<template>
  <!-- footer -->
  <div id="footerWrap" class="footer">
    <div class="footer_cont">
      <div class="footer_top">
        <a :href="$t('main[0].path')" class="footer_logo"
          ><img
            :src="`${resources}img/logo-footer-kop.png`"
            alt="한국오션플랫폼"
        /></a>

        <div class="footer_family">
          <!-- <div
            class="selectbox famile_rht"
            v-for="(item, idx) in familySites"
            :key="`footer-select-key-${idx}`"
          >
            <v-select
              v-model="familySiteValue[idx]"
              label="name"
              :options="item.options"
              :searchable="false"
              :clearable="true"
              :selectable="(option) => option.path"
              :placeholder="item.label"
              @input="goFamily(idx)"
              append-to-body
              :calculate-position="withPopper"
            >
            </v-select>
          </div> -->
          <div class="btn_biz">
            <a
              href="/files/pdf/kop_brochure.pdf"
              target="_blank"
              rel="noreferrer noopener"
              class="btn_m_download"
              >회사소개서 다운로드</a
            >
            <a
              href="https://epro.lsyesco.com/spLogin.do"
              target="_blank"
              rel="noreferrer noopener"
              class="btn_m_contract"
              >전자계약(협력사 포털)</a
            >
          </div>
        </div>
      </div>

      <div class="footer_link">
        <router-link
          v-for="(menu, idx) in $t('footer.list')"
          :key="`footer-list-${idx}`"
          :to="menu.path"
          :title="menu.title || null"
          :target="menu.target || null"
          :rel="menu.target === '_blank' ? 'noreferrer noopener' : null"
          >{{ menu.name }}</router-link
        >
      </div>
      <div class="footer_link mgt20">
        <!-- 2024-03-20 사용하지 않는 메일로 삭제 
        <span
          >일반문의 :
          <a href="mailto:hspcc_inquiry@hansunge.co.kr"
            >hspcc_inquiry@hansunge.co.kr</a
          ></span
        > -->
        <span
          >영업문의 : <a href="mailto:work@kop.co.kr">work@kop.co.kr</a></span
        >
        <span
          >채용문의 : <a href="mailto:insa@kop.co.kr">insa@kop.co.kr</a></span
        >
      </div>

      <div class="copyright">COPYRIGHT ⓒ2024 KOP. ALL RIGHTS RESERVED.</div>
    </div>
  </div>
  <!-- footer -->
</template>

<script>
import mixin from '@/mixins';
import { createPopper } from '@popperjs/core';

/**
 * @module components/pc/Bottom
 * @vue-data {Array} familySiteValue=Array - 패밀리 사이트 select value 배열
 * @vue-computed {Array} familySites - 패밀리 사이트 select option
 */
export default {
  mixins: [mixin],
  data() {
    return {
      familySiteValue: Array.from({ length: 2 }).fill(null)
    };
  },
  computed: {
    familySites() {
      return this.$t('footer.select').reverse();
    }
  },
  methods: {
    /**
     * 패밀리 사이트 이동 함수
     * @param {Number} idx 이동할 패밀리 사이트 index
     */
    goFamily(idx) {
      window.open(this.familySiteValue[idx].path);

      this.familySiteValue[idx] = null;
    },
    withPopper(dropdownList, component, { width }) {
      dropdownList.style.width = width;

      const popper = createPopper(component.$refs.toggle, dropdownList, {
        placement: 'top'
      });

      return () => popper.destroy();
    }
  }
};
</script>

<style lang="scss" scoped></style>
